import { useTranslation } from "react-i18next";
import { Outlet, useOutletContext, useSearchParams } from "react-router";
import { SubNav } from "../components/SubNav";
import Reviews from "./appraisals/Reviews";
import Scoring from "./appraisals/Scoring";
import { usePeopleCompany } from "./People";

/** Appraisals and performance (WP-24 wave R, HRX-08).
 *
 * Nobody on this site had ever been formally reviewed: Appraisal, Appraisal Cycle, Appraisal Template, Goal,
 * KRA and Employee Performance Feedback all held zero rows, on 103 active employees of whom 101 have a
 * manager. The reviewer relationship was there and had never been used. */

export const APPRAISAL_SCREENS = ["scoring"] as const;

export default function Appraisals() {
  const { t } = useTranslation();
  const company = usePeopleCompany();
  const [params] = useSearchParams();
  const query = params.get("company") ? `?company=${encodeURIComponent(params.get("company")!)}` : "";

  const items = [
    { key: "reviews", to: `/people/appraisals${query}`, label: t("apr.tabs.reviews"), end: true },
    ...APPRAISAL_SCREENS.map((k) => ({ key: k, to: `/people/appraisals/${k}${query}`, label: t(`apr.tabs.${k}`) })),
  ];

  return (
    <div data-appraisals>
      <SubNav items={items} label={t("apr.sections")} />
      <Outlet context={{ company }} />
    </div>
  );
}

const useCompany = () => useOutletContext<{ company: string }>().company;

export const AppraisalsIndex = () => <Reviews company={useCompany()} />;
export const AppraisalsScoring = () => <Scoring company={useCompany()} />;
